<template>
  <div v-if="$store.state.menu.History">
    <v-container fill-height fluid grid-list-xl>
      <Loader :loading="loading" />
      <v-layout justify-center wrap>
        <v-flex md12>
          <material-card color="green" title="Список загрузок" text="DTE">
            <v-btn color="primary" @click="getItemList(false)" text>
              Обновить
            </v-btn>

            <v-btn color="warning" class="ml-2" @click="importNow" text>
              Импорт товаров
            </v-btn>

            <div class="mt-2">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Поиск..."
                class="sticky search"
                :loading="loadingSearch"
                single-line
                hide-details
                clearable="true"
              ></v-text-field>
            </div>

            <v-data-table :headers="headers" :items="itemList" hide-actions>
              <template slot="headerCell" slot-scope="{ header }">
                <span
                  class="subheading font-weight-light text-success text--darken-3"
                  v-text="header.text"
                />
              </template>
              <template slot="items" slot-scope="{ item }">
                <td class="text-xs-left">
                  {{ item.id }}
                </td>
                <td class="text-xs-left">
                  {{ item.filename }}
                </td>
                <td class="text-xs-left">
                  <a
                    :href="`https://customerservice.uz/storage/serials/${item.filename}`"
                    >Скачать</a
                  >
                </td>
              </template>
            </v-data-table>

            <div class="horizontal-scroll">
              <v-pagination
                total-visible="8"
                v-if="last_page > 1"
                v-model="page"
                class="my-4"
                :length="last_page"
              ></v-pagination>
            </div>
          </material-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import Loader from "../components/helper/Loader";
import { mapMutations } from "vuex";

export default {
  data: () => ({
    exportFileName: "",
    json_fields_all_products: {
      "Наименование товара": "name",
      Артикул: "vendor_code",
      "Серийный номер": "serial_number",
      "Наклейка (с.н)": "code",
      "Стоимость покупуки": "conditional_price",
      Награда: "reward",
      Склад: "in_stock",
    },
    export_all_products: [],
    export_error_products: [],
    export_re_products: [],
    loadingExport: false,
    page: 1,
    searcher: null,
    loadingSearch: true,
    loading: true,
    last_page: 0,
    search: "",
    headers: [
      {
        sortable: false,
        text: "Номер",
        value: "id",
      },
      {
        sortable: false,
        text: "Файл",
        value: "dealer.title",
      },
      {
        sortable: false,
        text: "Файл",
        value: "dealer.phone_number",
      },
    ],
    itemList: [],
    exportID: null,
  }),
  components: { Loader },
  methods: {
    ...mapMutations(["SET_USER", "SET_BADGE_ORDERS"]),
    importNow() {
      this.$dialog
        .confirm(
          "Запрос будет длится достаточно долго. " +
            "Вам нельзя будет закрывать страницу, чтобы импортировать товары",
          {
            okText: "Импортировать товары",
            cancelText: "Отмена",
          }
        )
        .then(() => {
          this.loading = true;
          axios
            .get("admin/exchange-1c/import")
            .then((response) => {})
            .catch((error) => {})
            .finally(() => {
              this.loading = false;
              this.getItemList(true);
            });
        })
        .catch(() => {});
    },

    getItemList(noLoading) {
      if (!noLoading) this.loading = true;
      axios
        .get("admin/exchange-1c/list", {
          params: {
            page: this.page,
            search: this.search,
          },
        })
        .then((response) => {
          this.itemList = response.data.data;
          this.last_page = response.data.last_page;
        })
        .catch((error) => {})
        .finally(() => {
          this.loadingSearch = false;
          this.loading = false;
        });
    },

    closeExport() {
      this.getItemList(true);
      this.exportID = null;
    },
  },

  watch: {
    search() {
      this.loadingSearch = true;
      clearTimeout(this.searcher);
      this.searcher = setTimeout(() => {
        this.page = 1;
        this.getItemList(true);
      }, 1000);
    },
    page() {
      setTimeout(() => {
        this.getItemList();
      }, 300);
    },
  },
  mounted() {
    this.getItemList();
  },
};
</script>
